export default __webpack_public_path__ + "static/media/gharam.89a0bcda.jpg";